import {
  Datagrid,
  List,
  TextField,
  DateField,
  DateInput,
} from 'react-admin'

const logFilters = [
  <DateInput label="Start Date" source="dateStart" alwaysOn />,
  <DateInput label="End Date" source="dateEnd" alwaysOn />,
]
export const ReportCouponIssuesList = () => (
  <List filters={logFilters}>
    <Datagrid bulkActionButtons={false}>
      <DateField source="date" showTime />
      <TextField source="offer.title" />
      <TextField source="offer.store.name" />
      <TextField source="offer.store.city" />
      <TextField source="offer.store.state" />
      <TextField source="offerProvider" />
      <TextField source="user.name" />
      <TextField source="user.phoneNbr" />
      <TextField source="user.email" hidden />
      <TextField source="issueType" />
      <TextField source="description" />
    </Datagrid>
  </List>
)

